import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import React, { Fragment } from 'react';
import { useTheme } from 'styled-components';
import { StyledImage } from './ELearningSection.style';

export interface IELearningSectionProps{
  onArticleCardClick: (kbNumber: string) => void;
  kbArticleList: any;
  locale:any;
}

const ELearningSection = ({onArticleCardClick,kbArticleList=[],locale}:IELearningSectionProps) => {
  const theme = useTheme() as typeof DefaultUptimeTheme;

  return (
      <Card sx={{ borderRadius: '4x', maxHeight: '393px', boxShadow: `0px 0px 0px 1px ${theme.uptimeColors.grayScales.boxShadow}`}}>
        <CardHeader
          sx={{ padding: '16px 16px 8px'}}
          title={
            <Typography variant="h6" color="black">
              {locale?.elearning?.title}
            </Typography>
        }/>
        <CardContent
          sx={{ paddingTop: '0px', paddingBottom: '0px !important', maxHeight: 348, overflow: 'auto' }}
        >
          {kbArticleList?.length > 0 ? (
            kbArticleList.map((article: any, index: number) => (
              <Fragment key={article.id}>
                {index !== 0 && <Divider />}
                <Grid container>
                  <Grid item xs>
                    <Box padding="16px 0" onClick={() => onArticleCardClick(article.number)}>
                      <Grid container spacing={2} sx={{ cursor: 'pointer'}}>
                        <Grid item xs={4}>
                          <StyledImage src={article.image} alt="image" />
                        </Grid>
                        <Grid item xs={8}>
                          <Typography variant="subtitle2" sx={{ color: '#1D2026', fontWeight: 600 }}>
                            {article.name}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Fragment>
            ))
          ) : (
            <>{locale?.elearning?.noData}</>
          )}
        </CardContent>
      </Card>
  );
};

export default ELearningSection;